module.exports = __webpack_public_path__ + "1e5ceff0c5f63ad49f435d50e2a411f0.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/logos/sp-logo-white.png
// module id = 818
// module chunks = 0